import React from 'react';
import Choropleth from '@splunk/dashboard-visualizations/Choropleth';
import GeoRegistry from '@splunk/visualization-context/GeoRegistry';
import GeoJsonProvider from '@splunk/visualization-context/GeoJsonProvider';
import { GeoContextProvider } from '@splunk/visualization-context/GeoContext';

const geoRegistry = GeoRegistry.create();
geoRegistry.addDefaultProvider(new GeoJsonProvider());

const logBounds = { x: { min: 0, max: 800 }, y: { min: 0, max: 600 } };

const ChoroplethProps = {
    mode: '',
    style: {},
    loading: false,
    width: 800,
    height: 600,
    onOptionsChange: () => {},
    onEventTrigger: () => {},
    onRequestParamsChange: () => {},
    options: {
        name: 'USA',
        source: 'geo://default/us',
        projection: 'mercator',
        sourceBounds: { lat: { min: -60, max: 85 }, long: { min: -180, max: 180 } },
        logicalBounds: logBounds,
        fillColor: '#EAEFF2',
        strokeColor: '#689C8D',
        strokeHighlightColor: '#000',
        selector: '.feature',
        geoFeatureGroups: [
            {
                name: 'lower48',
                featureMatcher: {
                    property: 'postal',
                    regex: '^(?!(AK|HI))',
                },
                sourceBounds: {
                    lat: { min: 24, max: 50 },
                    long: { min: -130, max: -60 },
                },
            },
            {
                name: 'Alaska',
                featureMatcher: {
                    property: 'postal',
                    regex: 'AK',
                },
                logicalBounds: {
                    x: { min: 100, max: 200 },
                    y: { min: 325, max: 425 },
                },
                sourceBounds: {
                    lat: { min: 45, max: 72 },
                    long: { min: -180, max: -120 }, // manually cutoff the Alaskan islands in the eastern hemisphere by taking only the western hemisphere parts
                },
            },
            {
                name: 'Hawaii',
                featureMatcher: {
                    property: 'postal',
                    regex: 'HI',
                },
                logicalBounds: {
                    x: { min: 250, max: 350 },
                    y: { min: 375, max: 475 },
                },
                sourceBounds: {
                    lat: { min: 18.665677, max: 22.461292 },
                    long: { min: -160.921571, max: -154.242648 },
                },
            },
        ],
    },
    encoding: {
        featureId: 'primary[0]',
        value: 'primary[1]',
        fill: {
            field: 'primary[1]',
            format: {
                type: 'gradient',
                ranges: [5, 30, 45, 55, 150, 220, 300],
                values: ['#b3fff0', '#99ffec', '#87f5df', '#7af5de', '#60ebd1', '#4be3c5', '#09D0AC'],
            },
        },
    },
    dataSources: {
        primary: {
            data: {
                columns: [
                    [
                        'US-AL',
                        'US-AR',
                        'US-AZ',
                        'US-CA',
                        'US-CO',
                        'US-CT',
                        'US-FL',
                        'US-GA',
                        'US-IA',
                        'US-ID',
                        'US-IL',
                        'US-IN',
                        'US-KS',
                        'US-KY',
                        'US-LA',
                        'US-MA',
                        'US-MD',
                        'US-MI',
                        'US-MN',
                        'US-MO',
                        'US-MT',
                        'US-NC',
                        'US-NE',
                        'US-NJ',
                        'US-NM',
                        'US-NV',
                        'US-NY',
                        'US-OH',
                        'US-OK',
                        'US-OR',
                        'US-PA',
                        'US-RI',
                        'US-SC',
                        'US-SD',
                        'US-TN',
                        'US-TX',
                        'US-UT',
                        'US-VA',
                        'US-WA',
                        'US-WI',
                    ],
                    [
                        17,
                        3,
                        65,
                        385,
                        69,
                        9,
                        142,
                        23,
                        11,
                        6,
                        28,
                        43,
                        12,
                        33,
                        12,
                        8,
                        9,
                        23,
                        6,
                        14,
                        10,
                        70,
                        8,
                        3,
                        23,
                        28,
                        62,
                        58,
                        17,
                        28,
                        43,
                        6,
                        8,
                        6,
                        33,
                        225,
                        9,
                        49,
                        48,
                        29,
                    ],
                ],
                fields: [
                    {
                        name: 'us_state',
                    },
                    {
                        name: 'values',
                    },
                ],
            },
        },
    },
};

export default () => (
    <GeoContextProvider value={geoRegistry}>
        <Choropleth {...ChoroplethProps} />
    </GeoContextProvider>
);
